module.exports = __webpack_public_path__ + "img/box_empty.324ed0ab.svg";